









import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
    model: {
        prop: 'modelValue',
        event: 'change'
    }
})
export default class ToggleSwitchControl extends Vue {
    @Prop({ type: Boolean, default: false })
    private modelValue!: boolean;
    @Prop({ type: Boolean, default: true })
    private trueValue!: boolean;
    @Prop({ type: Boolean, default: false })
    private falseValue!: boolean;
    @Prop({ type: Boolean, default: false })
    private disabled!: boolean;
    @Prop({ type: Boolean, default: false})
    private blue!: boolean;

    get shouldBeChecked(): boolean {
        // Note that `true-value` and `false-value` are camelCase in the JS
        return this.modelValue === this.trueValue
    }

    updateInput(event: any) {
        if (this.disabled) {
            return;
        }
        let isChecked = event.target.checked;
        this.$emit('change', isChecked ? this.trueValue : this.falseValue);
    }
}
